import { Store, SerializedData } from "bernie-core";
import { observable, action } from "mobx";
import { formatText } from "bernie-l10n";
import { Logger } from "bernie-logger";
import { PillId } from "components/flexComponents/Packages/utils/PackagesEnum";
import {
  tripLengthPillFilter,
  starRatingPillFilter,
  flightClassPillFilter,
} from "components/flexComponents/Packages/utils/PillFiltersConfig";

export class PackagePillStore extends Store {
  @observable
  public tripLengthName: string;

  @observable
  public starRatingName: string;

  @observable
  public flightClassName: string;

  @observable
  public tripLengthToggleState: boolean;

  @observable
  public starRatingToggleState: boolean;

  @observable
  public flightClassToggleState: boolean;

  public static DEFAULTS = {
    tripLengthName: "",
    starRatingName: "",
    flightClassName: "",
    tripLengthToggleState: false,
    starRatingToggleState: false,
    flightClassToggleState: false,
  };

  public constructor(state: SerializedData, logger: Logger) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
    this.reset();
  }

  @action
  public reset() {
    this.resetPillNames();
    this.resetToggles();
  }

  @action
  public updatePill(pillId: string, newPillName: string) {
    switch (pillId) {
      case PillId.TRIP_LENGTH:
        this.tripLengthName = newPillName;
        this.tripLengthToggleState = true;
        break;
      case PillId.STAR_RATING:
        this.starRatingName = newPillName;
        this.starRatingToggleState = true;
        break;
      case PillId.FLIGHT_CLASS:
        this.flightClassName = newPillName;
        this.flightClassToggleState = true;
        break;
      default:
        break;
    }
  }

  public getPillName(pillId: string): string {
    switch (pillId) {
      case PillId.TRIP_LENGTH:
        return this.tripLengthName;
      case PillId.STAR_RATING:
        return this.starRatingName;
      case PillId.FLIGHT_CLASS:
        return this.flightClassName;
      default:
        return "";
    }
  }

  public getPillToggleState(pillId: string): boolean {
    switch (pillId) {
      case PillId.TRIP_LENGTH:
        return this.tripLengthToggleState;
      case PillId.STAR_RATING:
        return this.starRatingToggleState;
      case PillId.FLIGHT_CLASS:
        return this.flightClassToggleState;
      default:
        return false;
    }
  }

  private resetToggles() {
    this.tripLengthToggleState = false;
    this.starRatingToggleState = false;
    this.flightClassToggleState = false;
  }

  private resetPillNames() {
    [tripLengthPillFilter, starRatingPillFilter, flightClassPillFilter].map((pill) => {
      switch (pill.id) {
        case PillId.TRIP_LENGTH:
          this.tripLengthName = formatText(pill.name);
          break;
        case PillId.STAR_RATING:
          this.starRatingName = formatText(pill.name);
          break;
        case PillId.FLIGHT_CLASS:
          this.flightClassName = formatText(pill.name);
          break;
      }
    });
  }
}
